// extracted by mini-css-extract-plugin
export default {"square":"ROISquare_square__LFote","visible":"ROISquare_visible__UGh5R"};